import React, { ChangeEvent , useRef } from 'react';
import type {FileData, TransactionDetails} from '../types/StockhornTypes';
import './TransactionTable.css';
interface FileSelectorProps {
  onFilesSelected: (files: TransactionDetails[]) => void;
  setFileName: (name: string) => void;
  onLoading?: () => void;
}

const FileSelector: React.FC<FileSelectorProps> = ({ onFilesSelected, setFileName, onLoading }) => {
  const fileInputNameRef = useRef<HTMLInputElement>(null);
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      onLoading && onLoading();
      const filePromises = Array.from(files).map((file) => {
        return new Promise<FileData>((resolve) => {
          const reader = new FileReader();
          reader.onload = () => {
            resolve({
              name: file.name,
              content: reader.result as string,
            });
          };
          reader.readAsText(file); // Use readAsDataURL for images, etc.
        });
      });

      // Wait for all files to be read and pass data to parent
      Promise.all(filePromises).then((fileData) => {
        try{
            const validatedFiles = fileData.map((file) => {
              const parsed = JSON.parse(file.content);
              if (!Array.isArray(parsed)) {
                throw new Error(`File ${file.name}: Expected an array of transactions`);
              }
              return { ...file, parsedContent: parsed};
            });
            const allRows: any[]= [];
            const allNames: string[] = [];
            validatedFiles.forEach(file => {file.parsedContent.forEach((row:any) => allRows.push(row));allNames.push(file.name);});
            onFilesSelected(fileData.length>1 ? allRows.sort((a, b) => {
              const dateA = new Date(a.Date);
              const dateB = new Date(b.Date);
              return dateA.getTime() - dateB.getTime()}) : allRows);
              const names = allNames.join(allNames.length ? ',':'')
            setFileName(names);
            // if (fileInputNameRef.current) {
            //     fileInputNameRef.current.value = names;
            // }
        }
        catch(e){
            alert('Error parsing JSON file: '+e+'\nPlease ensure the file is valid JSON.');
            if (fileInputNameRef.current) {
                fileInputNameRef.current.value = '';
            }
            return[];
        }
      });
    }
  };

  return (
    <div>
      <input
        className="fileInput"
        ref={fileInputNameRef} 
        type="file"
        accept=".json" // Specify allowed file types
        multiple // Allow multiple files
        onChange={handleFileChange}
      />
    </div>
  );
};

export default FileSelector;